import React, { useEffect } from 'react';
import { useScrollBlock } from '../../../hooks/useScrollBlock';
import { DetailsViewLoader } from '../details-view-loader/details-view-loader';
import { useInputContext } from '../use-input-context';
import { useDetailsParams } from '../utils';
import css from './details-modal.module.scss';

export function DetailsModal() {
  const [blockScroll, allowScroll] = useScrollBlock();

  useEffect(() => {
    blockScroll();

    return () => allowScroll();
  }, [allowScroll, blockScroll]);

  const params = useDetailsParams();
  const input = useInputContext();

  if (params === null) {
    throw new Error('DetailsPage must be used within a Route with a path that includes "/details/:type/:id"');
  }

  return (
    <div className={css.container}>
      <DetailsViewLoader
        id={params.id}
        type={params.type}
        orderByProviderId={input.orderByProviderId}
        orderByServiceType={input.orderByServiceType}
      />
    </div>
  );
}
